export default "__VITE_ASSET__CfeWCE2H__"